import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasCompletedOnboarding } from '../lib/onboarding';
import CaregiverDashboard from './dashboards/CaregiverDashboard';
import ClientDashboard from './dashboards/ClientDashboard';
import OperationsDashboard from './dashboards/OperationsDashboard';
import SystemAdminDashboard from './dashboards/SystemAdminDashboard';

export default function Dashboard(): React.JSX.Element {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;
  if (!hasCompletedOnboarding(user)) return <Navigate to="/onboarding" replace />;

  switch (user.role) {
    case 'caregiver':
      return <CaregiverDashboard />;
    case 'client':
      return <ClientDashboard />;
    case 'operations':
      return <OperationsDashboard />;
    case 'system-admin':
      return <SystemAdminDashboard />;
  }
}
